module.exports = __webpack_public_path__ + "media/images/mail_template/twitter-d752d39761ebd23536365467ba03aae6.png";